import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function Events() {
  const getUsername = Cookies.get("username");
  const API_URL = BASE_URL + "/getevents"; // ✅ changed to events

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const sortedEvents = res.data.sort((a, b) => {
          const aTime = a.createdAt?._seconds || 0;
          const bTime = b.createdAt?._seconds || 0;
          return bTime - aTime;
        });
        setEvents(sortedEvents);
        setLoading(false);
      })
      .catch((error) => {
        console.log("There was an error", error);
        setLoading(false);
      });
  }, []);

  // ✅ Search table
  const searchTable = () => {
    const input = document.getElementById("search");
    const filter = input.value.toLowerCase();
    const table = document.getElementById("Table");
    const rows = table.getElementsByTagName("tr");

    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName("td");
      let match = false;

      for (let j = 0; j < cells.length; j++) {
        if (cells[j]) {
          const cellValue = cells[j].textContent || cells[j].innerText;
          if (cellValue.toLowerCase().indexOf(filter) > -1) {
            match = true;
            break;
          }
        }
      }
      rows[i].style.display = match ? "" : "none";
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <ToastContainer position="top-center" />
      <h2>All Events</h2>
      <br />
      <div className="row mb-3">
        <div className="col-sm-2">
          {/* ✅ Add Event Button */}
          <Link to="/addevent">
            <button className="btn btn-primary w-100">+ Add Event</button>
          </Link>
        </div>
        <div className="col-sm-4">
          {/* ✅ Search input in same row */}
          <input
            type="text"
            className="form-control"
            id="search"
            placeholder="Search events..."
            onKeyUp={searchTable}
          />
        </div>
      </div>

      <table className="table table-striped table-light" id="Table">
        <thead>
          <tr>
            <th scope="col">Event Name</th>
            <th scope="col">Sport Category</th>
            <th scope="col">City / Location</th>
            <th scope="col">Event Code</th>
            <th scope="col">Event Date</th>
            <th scope="col">Created At</th>
            <th scope="col">Delete</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => {
            const createdAt = event.createdAt?._seconds
              ? new Date(event.createdAt._seconds * 1000).toLocaleString()
              : "N/A";

            return (
              <tr key={event.Id}>
                <td>{event.eventName}</td>
                <td>{event.sportCategory}</td>
                <td>{event.cityLocation}</td>
                <td>{event.eventCode}</td>
                <td>{event.eventDate}</td>
                <td>{createdAt}</td>
                <td>
                  <Link to={`/deleteevent/${event.Id}`}>
                    <i className="bi bi-trash3 text-danger"></i>
                  </Link>
                </td>
              </tr>
            );
          })}
          {events.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                No events available to show.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
